import { render, staticRenderFns } from "./ContentBlockVideo.vue?vue&type=template&id=1e13b2fe"
import script from "./ContentBlockVideo.vue?vue&type=script&lang=ts"
export * from "./ContentBlockVideo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports